import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getData } from "../../services/dataService.jsx";
import "../../assets/styles/bootstrap.css";
import ListGroup from "react-bootstrap/ListGroup";
import Card from "react-bootstrap/Card";
import { useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Badge from "react-bootstrap/Badge";
import DepartedForm from "../../components/departed/DepartedForm.jsx";
import DeleteModal from "../../components/DeleteModal.jsx";
import Button from "react-bootstrap/Button";
import { useNavigate } from "react-router-dom";
import ListContainer from "../../components/containers/ListContainer";

function DepartedDetails() {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const [departed, setDeparted] = useState([]);
  const [graveID] = useState("");
  const [identifier] = useState("");
  const [showDepartedForm, setShowDepartedForm] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [updateSuccesful, setUpdateSuccesful] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getDeparted = async () => {
      try {
        const data = await getData(`/departed/${location.state.uuid}`);
        setDeparted(data);
      } catch (error) {
        console.log("Error fetching data: ", error.message);
      }
    };
    getDeparted();
    setUpdateSuccesful(false);
  }, [location.state.uuid, updateSuccesful]);

  const handleClick = (uuid) => {
    navigate("/gravedetails", { state: { uuid: uuid } });
  };

  const handleShowDepartedForm = () => {
    setShowDepartedForm(true);
  };

  const handleCloseDepartedForm = (isSuccesful) => {
    setShowDepartedForm(false);
    if (isSuccesful) {
      setUpdateSuccesful(true);
    }
  };

  const handleShowDeleteModal = () => {
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = (deleteType) => {
    setShowDeleteModal(false);
    if (deleteType === "departed") {
      navigate("/departed");
    }
  };

  const romeNumbersArray = ["I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII"];
  const arabToRomeNumber = (number) => {
    return romeNumbersArray[number - 1];
  }

  const renderDates = (departed) => {
    return (<>
      {
        (departed?.bornYear) && (
          (departed?.bornMonth && departed?.bornDay) ?
            ((i18n.language === "en") ?
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("born")}</span>
                {`: ${departed?.bornMonth}-${departed?.bornDay}-${departed?.bornYear} `}
              </ListGroup.Item>) :
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("born")}</span>
                {`: ${departed?.bornYear}. ${arabToRomeNumber(departed?.bornMonth)}. ${departed?.bornDay}. `}
              </ListGroup.Item>)) :
            (<>
              {(departed?.bornYear) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("bornYear")}</span>
                {`: ${departed.bornYear} `}
              </ListGroup.Item>}
              {(departed?.bornMonth) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("bornMonth")}</span>
                {`: ${departed.bornMonth} `}
              </ListGroup.Item>}
              {(departed?.bornDay) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("bornDay")}</span>
                {`: ${departed.bornDay} `}
              </ListGroup.Item>}
            </>)
        )
      }
      {
        (departed?.deathYear) && (
          (departed?.deathMonth && departed?.deathDay) ?
            ((i18n.language === "en") ?
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("death")}</span>
                {`: ${departed?.deathMonth}-${departed?.deathDay}-${departed?.deathYear}`}
              </ListGroup.Item>) :
              (<ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("death")}</span>
                {`: ${departed?.deathYear}. ${arabToRomeNumber(departed?.deathMonth)}. ${departed?.deathDay}.`}
              </ListGroup.Item>)) :
            (<>
              {(departed?.deathYear) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathYear")}</span>
                {`: ${departed.deathYear} `}
              </ListGroup.Item>}
              {(departed?.deathMonth) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathMonth")}</span>
                {`: ${departed.deathMonth} `}
              </ListGroup.Item>}
              {(departed?.deathDay) && <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathDay")}</span>
                {`: ${departed.deathDay} `}
              </ListGroup.Item>}
            </>)
        )
      }
    </>)
  }

  return (
    <ListContainer>
      <Card className="card-component">
        <Card.Body>
          <div className="d-flex justify-content-end">

            <Badge
              className="action-btn p-2 m-2"
              style={{
                width: "40px",
                height: "40px",
                fontSize: "large",
                justifyContent: "center",
                alignContent: "center"
              }}
              bg="secondary"
              onClick={() => handleShowDepartedForm()}
            >
              <i className="bi bi-pen"></i>
            </Badge>
            <Badge
              className="action-btn p-2 my-2"
              style={{
                width: "40px",
                height: "40px",
                fontSize: "large",
                justifyContent: "center",
                alignContent: "center"
              }}
              bg="secondary"
              onClick={() => handleShowDeleteModal()}
            >
              <i className="bi bi-person-dash"></i>
            </Badge>
          </div>
          {" "}
          <Card.Header>
            {departed?.namePrefix && ` ${departed.namePrefix} `}
            {departed?.familyName && ` ${departed.familyName} `}
            {departed?.bornFamilyName && (
              <span style={{ fontWeight: "normal" }}>
                {"(" + departed.bornFamilyName + ")"}{" "}
              </span>
            )}
            {departed?.givenName && ` ${departed.givenName} `}
          </Card.Header>
          <ListGroup className="list-group-flush">
            {departed?.familyName && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("familyName")}</span>
                {`: ${departed.familyName} `}
              </ListGroup.Item>
            )}
            {departed?.bornFamilyName && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>
                  {t("bornFamilyName")}
                </span>
                {`: ${departed.bornFamilyName} `}
              </ListGroup.Item>
            )}
            {departed?.givenName && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("givenName")}</span>
                {`: ${departed.givenName} `}
              </ListGroup.Item>
            )}
            {renderDates(departed)}
            {departed?.birthPlace?.placeName && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("birthPlace")}</span>
                {`: ${departed.birthPlace?.placeName} `}
              </ListGroup.Item>
            )}
            {departed?.deathPlace?.placeName && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("deathPlace")}</span>
                {`: ${departed.deathPlace?.placeName} `}
              </ListGroup.Item>
            )}
            {departed?.occupation?.occupationName && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("occupation")}</span>
                {`: ${departed?.occupation?.occupationName} `}
              </ListGroup.Item>
            )}
            {departed?.heroism && (
              <ListGroup.Item>
                <span style={{ fontWeight: "bold" }}>{t("heroism")}</span>
                {`: ${departed.heroism} `}
              </ListGroup.Item>
            )}
            {departed?.description && (
              <Card.Text>{departed?.description}</Card.Text>
            )}
          </ListGroup>
          <div className="d-flex justify-content-end">
            <Button
              variant="link"
              className="more-btn"
              style={{ textDecoration: "none", color: "grey" }}
              onClick={() => handleClick(departed.graveID)}
            >
              {t("moreToGrave")}
            </Button>
          </div>
        </Card.Body>
      </Card>
      <DepartedForm
        show={showDepartedForm}
        onClose={handleCloseDepartedForm}
        graveID={graveID}
        departedID={departed.uuid}
        formType="update"
      />
      <DeleteModal
        show={showDeleteModal}
        onClose={handleCloseDeleteModal}
        ID={departed.uuid}
        identifier={identifier}
        deleteType="departed"
      />
    </ListContainer>
  );
}

export default DepartedDetails;
